import { lazy, useEffect, useState } from 'react';
import { loadTgsAnimation } from '@/utils/tgsToLottie';

const LottieAnimation = lazy(() => import('./LottieAnimation').then(module => ({
  default: module.LottieAnimation
})));

interface TelegramStickerProps {
  tgsUrl: string;
  style?: React.CSSProperties;
  loop?: boolean;
  autoplay?: boolean;
}

export const TelegramSticker = ({
  tgsUrl,
  style,
  loop = true,
  autoplay = true,
}: TelegramStickerProps) => {
  const [animationData, setAnimationData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadAnimation = async () => {
      try {
        if (tgsUrl.endsWith('.tgs')) {
          const data = await loadTgsAnimation(tgsUrl);
          setAnimationData(data);
        } else {
          const response = await fetch(tgsUrl);
          const data = await response.json();
          setAnimationData(data);
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load sticker');
        console.error('Error loading sticker:', err);
      }
    };

    loadAnimation();
  }, [tgsUrl]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!animationData) {
    return;
  }

  return (
    <LottieAnimation
      animationData={animationData}
      style={style}
      loop={loop}
      autoplay={autoplay}
    />
  );
};
